import React from 'react';
import { CheckCircle2, Clock, AlertTriangle, Send, UserCheck, ShieldCheck } from 'lucide-react';

const ACTIVITIES = [
  {
    id: 'act-dbs-001',
    icon: ShieldCheck,
    iconColor: 'text-warning',
    iconBg: 'bg-warning/10',
    title: 'DBS renewal reminder',
    detail: 'Priya Nair — DBS expires 15 May 2026 · Update Service ref: 12345678',
    time: 'Today',
    user: 'System',
  },
  {
    id: 'act-rtw-001',
    icon: UserCheck,
    iconColor: 'text-success',
    iconBg: 'bg-success/10',
    title: 'Right to Work re-verified',
    detail: 'Hassan Clarke — BRP renewed · Share Code confirmed · Valid until 31 Dec 2028',
    time: '02 May',
    user: 'Sarah R.',
  },
  {
    id: 'act-001',
    icon: CheckCircle2,
    iconColor: 'text-success',
    iconBg: 'bg-success/10',
    title: 'Timesheet approved',
    detail: 'Amara Okafor — Week 18 · 38.5 hrs',
    time: '06:52',
    user: 'Sarah R.',
  },
  {
    id: 'act-002',
    icon: Clock,
    iconColor: 'text-warning',
    iconBg: 'bg-warning/10',
    title: 'Timesheet pending approval',
    detail: 'Cian Walsh — Week 18 · 42.0 hrs (OT flag)',
    time: '06:30',
    user: 'System',
  },
  {
    id: 'act-003',
    icon: UserCheck,
    iconColor: 'text-primary',
    iconBg: 'bg-primary/10',
    title: 'Worker auto-enrolled to NEST pension',
    detail: 'Fatima Byrne — Category A, 5% Ee / 3% Er',
    time: 'Yesterday',
    user: 'System',
  },
  {
    id: 'act-005',
    icon: Send,
    iconColor: 'text-success',
    iconBg: 'bg-success/10',
    title: 'RTI FPS submitted to HMRC',
    detail: 'Week 17 · Accepted · Ref: FPS-2026-W17-SR',
    time: '27 Apr',
    user: 'Sarah R.',
  },
  {
    id: 'act-006',
    icon: AlertTriangle,
    iconColor: 'text-danger',
    iconBg: 'bg-danger/10',
    title: 'Tax code mismatch flagged',
    detail: 'David Mensah — Code 1100L applied, HMRC shows 1257L',
    time: '25 Apr',
    user: 'System',
  },
];

export default function ActivityFeed() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-[14px] font-600 text-foreground">Recent Activity</h3>
        <button className="text-[12px] font-500 text-primary hover:text-primary/80 transition-colors">
          View all
        </button>
      </div>
      <ul className="space-y-3">
        {ACTIVITIES?.map((item) => (
          <li key={item?.id} className="flex items-start gap-3 group">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 mt-0.5 ${item?.iconBg}`}>
              <item.icon size={14} className={item?.iconColor} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[13px] font-500 text-foreground leading-snug">{item?.title}</p>
              <p className="text-[12px] text-muted-foreground mt-0.5 truncate">{item?.detail}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="text-[11px] text-muted-foreground">{item?.time}</p>
              <p className="text-[11px] font-500 text-muted-foreground mt-0.5">{item?.user}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}